import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpService } from '../shared/services/http.service';
import { TableService } from '../shared/services/tableService/table.service';

@Component({
  selector: 'app-export-pdf-table',
  standalone: false,
  templateUrl: './export-pdf-table.component.html',
  styleUrl: './export-pdf-table.component.scss',
})
export class ExportPdfTableComponent implements OnChanges {
  @ViewChild('ftlcontainer') ftlcontainer: ElementRef | any;
  @Input() data: any;
  @Input() raData: any;
  @Input() type: any;
  @Input() newFontSize: any;
  @Input() newHeight: any;

  destinCol: any;
  dbDataSource: any;
  tableData: any;
  chargesList: any;
  countryListArr: any;
  mauntList: any;
  tableType: any = 'ftl';
  fileType: any;
  subscription: any;
  agreemntData: any;
  displayedCol = [
    'from',
    'to',
    'euro-inbound',
    'euro-return',
    'euro-roundtrip',
    'mega-inbound',
    'mega-return',
    'mega-roundtrip',
    'jumbo-inbound',
    'jumbo-return',
    'jumbo-roundtrip',
    'giga-inbound',
    'giga-return',
    'giga-roundtrip',
  ];
  effectiveDate: any;
  fixed_order = ['Distance', 'euro', 'mega', 'jumbo', 'giga'];

  constructor(
    public appService: AppService,
    public httpService: HttpService,
    public tableService: TableService
  ) {
    // this.subscription = this.appService.fileExportEmit.subscribe((evt:any) =>{
    //   if(evt === 'PDF'){
    //     let matRow = this.ftlcontainer.nativeElement.querySelectorAll('.mat-mdc-row');
    //     let matHeader = this.ftlcontainer.nativeElement.querySelectorAll('.mat-mdc-header-row');
    //     console.log('matRow', matRow, matHeader);
    //     matRow.forEach((component: any) => {
    //       component.style.height = `${ this.tableService.newHeight}px`;
    //   });
    //   matHeader.forEach((component: any) => {
    //       component.style.height = `${ this.tableService.newHeight}px`;
    //   });
    //   }
    // })
  }

  getCountryList(evt: any) {
    this.countryListArr = this.appService.countryListArr;
    const convertedData = evt.map((item: any) => {
      const countryObj = this.countryListArr.find(
        (country: any) => country.CountryName === item.country
      );
      const countryId = countryObj ? countryObj.CountryID : null;
      return {
        country: countryId,
        rate: parseFloat(item.rate),
      };
    });
    this.mauntList = convertedData;
  }

  deleteIconUpdate() {
    this.destinCol = [];
    if (this.tableType === 'fixed') {
      this.displayedCol.forEach((col) => {
        if (['service'].includes(col)) {
          if (!this.destinCol.includes('Distance'))
            this.destinCol.push('Distance');
        } else {
          if (!this.destinCol.includes(col.split('-')[0])) {
            this.destinCol.push(col.split('-')[0]);
          }
        }
      });
    } else {
      this.displayedCol.forEach((col: any) => {
        if (['from', 'to'].includes(col)) {
          if (!this.destinCol.includes('Distance'))
            this.destinCol.push('Distance');
        } else {
          if (!this.destinCol.includes(col.split('-')[0])) {
            this.destinCol.push(col.split('-')[0]);
          }
        }
      });
      this.destinCol = this.destinCol.sort((a: string, b: string) => {
        return this.fixed_order.indexOf(a) - this.fixed_order.indexOf(b);
      });
      this.displayedCol = [];
      this.destinCol.map((i: string) => {
        if (i === 'Distance') this.displayedCol.push('from', 'to');
        else
          this.displayedCol.push(
            `${i}-inbound`,
            `${i}-return`,
            `${i}-roundtrip`
          );
      });
    }

    // let comp = document.getElementsByClassName('new-font-size');
    // for (let i = 0; i < comp.length; i++) {
    //   // (comp[i] as HTMLElement).style.fontSize = `${newFontSize}px`;
    //   (comp[i] as HTMLElement).style.lineHeight = `${ this.tableService.newHeight}px`;
    // }
  }

  styleUpdate() {
    let matRow =
      this.ftlcontainer.nativeElement.querySelectorAll('.mat-mdc-row');
    let matHeader = this.ftlcontainer.nativeElement.querySelectorAll(
      '.mat-mdc-header-row'
    );

    matRow.forEach((component: any) => {
      component.style.height = `${this.tableService.newHeight + 2}px`;
    });
    matHeader.forEach((component: any) => {
      component.style.height = `${this.tableService.newHeight + 2}px`;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      let bindData = changes['data'].currentValue;
      this.tableData = null;
      this.chargesList = bindData.charge;
      this.data = bindData.data;
      this.tableData = bindData.name;
      this.effectiveDate = bindData.effectiveDate;

      this.getCountryList(bindData.maut);
      this.displayedCol = [];
      this.dbDataSource = [];
      this.dbDataSource = this.data;
      this.displayedCol = Object.keys(this.dbDataSource[0]);
      this.deleteIconUpdate();
      // this.tableData = this.appService.rateDateSource[this.appService.selectedItem]
    }
    if (changes['raData']?.currentValue) {
      this.agreemntData = changes['raData']?.currentValue;
    }
    if (changes['type']?.currentValue) {
      this.fileType = changes['type']?.currentValue;
    }
  }
  findCountryName(i: number): string {
    return i
      ? this.appService.countryListArr.find((item: any) => item.CountryID === i)
          .CountryName
      : '';
  }

  formatElementData(val: any) {
    return Number(val) ? '' + Number(val).toFixed(2) : null;
  }
  formatMautData(val: any) {
    return '' + Number(val).toFixed(3);
  }
}
